module.exports = __webpack_public_path__ + "img/alux.54ba05bf.jpg";